export const iconFontAwesomeAlphabetZ = (
	<i className="fa-solid fa-z"></i>
);
